/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ar_target_height_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target height`)
};

const es_ar_target_height_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura objetivo`)
};

const de_ar_target_height_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielhöhe`)
};

const nl_ar_target_height_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doelhoogte`)
};

const fr_ar_target_height_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauteur cible`)
};

const it_ar_target_height_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altezza target`)
};

const pt_br2_ar_target_height_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura de destino`)
};

const pt_ar_target_height_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura alvo`)
};

const ja_ar_target_height_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目標高さ`)
};

const zh_ar_target_height_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标高度`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ar_target_height_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ar_target_height_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ar_target_height_label", locale)
	if (locale === "en") return en_ar_target_height_label(inputs)
	if (locale === "es") return es_ar_target_height_label(inputs)
	if (locale === "de") return de_ar_target_height_label(inputs)
	if (locale === "nl") return nl_ar_target_height_label(inputs)
	if (locale === "fr") return fr_ar_target_height_label(inputs)
	if (locale === "it") return it_ar_target_height_label(inputs)
	if (locale === "pt-BR") return pt_br2_ar_target_height_label(inputs)
	if (locale === "pt") return pt_ar_target_height_label(inputs)
	if (locale === "ja") return ja_ar_target_height_label(inputs)
	return zh_ar_target_height_label(inputs)
};